var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card panel-white" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("label", [
        _vm._v(_vm._s(_vm.$t("message.my_reservations.cleaner_name")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row no-gutters d-flex h-100" }, [
        _c("div", { staticClass: "col-md-2 col-2" }, [
          _c("img", {
            staticClass: "img-fluid rounded-circle",
            attrs: { src: _vm.showPicture(_vm.order.professional), alt: "" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-10 col-10 pl-2 align-self-center" }, [
          _vm.serviceRequest.service_request_status_id >= 3
            ? _c("div", [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("firstName")(_vm.order.professional.full_name)
                    ) +
                    "\n        "
                )
              ])
            : _c("div", { staticClass: "text-remark" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "message.service_request.service_request_waiting_confirmation"
                      )
                    ) +
                    "\n        "
                )
              ])
        ])
      ]),
      _vm._v(" "),
      _vm.order.professional &&
      _vm.order.paid_status === 1 &&
      _vm.serviceRequest.payment_status > 0
        ? _c("div", { staticClass: "row mt-3 no-gutters" }, [
            _c("div", { staticClass: "col-6 pr-1" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-outline-info btn-block",
                  attrs: { href: "tel:" + _vm.order.professional.phone }
                },
                [
                  _c("i", { staticClass: "fas fa-phone" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("message.button.call")) + "\n        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 pl-1" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-outline-info btn-block",
                    attrs: {
                      to: {
                        path: "/message",
                        query: { cid: 0, pid: _vm.order.professional.id }
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-comment-alt-lines" }),
                    _vm._v(
                      " " + _vm._s(_vm.$t("message.button.chat")) + "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7063c3fa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7063c3fa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceRequest/Components/ProfessionalSection.vue
// module id = 2054
// module chunks = 0